export default __webpack_public_path__ + "static/media/flayer66.944217fa.jpg";